import { useLanguage } from "@/contexts/LanguageContext";
import { Button } from "@/components/ui/button";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface Props {
  open: boolean;
  branchName: string;
  prepTime: number | null;
  onContinue: () => void;
  onChooseAnother: () => void;
}

export default function BusyConfirmDialog({ open, branchName, prepTime, onContinue, onChooseAnother }: Props) {
  const { t } = useLanguage();

  return (
    <AlertDialog open={open} onOpenChange={(o) => !o && onChooseAnother()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            ⚠️ {t("branch.branchBusyTitle")}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {t("branch.branchBusyDesc")}
            {prepTime && (
              <span className="block mt-1">
                {t("branch.readyIn").replace("{min}", String(prepTime))} ({t("branch.mayVary")})
              </span>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button variant="outline" onClick={onChooseAnother}>
            {t("branch.chooseAnother")}
          </Button>
          <Button onClick={onContinue}>
            {t("branch.continue")}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
